import { render, staticRenderFns } from "./ReclaimPins.vue?vue&type=template&id=5d6dc0fc&"
import script from "./ReclaimPins.vue?vue&type=script&lang=js&"
export * from "./ReclaimPins.vue?vue&type=script&lang=js&"
import style0 from "./ReclaimPins.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports